import type {AuthSession} from './auth.models';

const AUTH_SESSION_STORAGE_KEY = 'item-tracker.auth.session';

export function isAuthSessionActive(session: AuthSession | null): session is AuthSession {
  return typeof session?.accessToken === 'string' && session.accessToken.trim().length > 0;
}

export function readStoredAuthSession(): AuthSession | null {
  try {
    const raw = localStorage.getItem(AUTH_SESSION_STORAGE_KEY);
    if (!raw) {
      return null;
    }

    return JSON.parse(raw) as AuthSession;
  } catch {
    return null;
  }
}

export function writeStoredAuthSession(session: AuthSession): void {
  try {
    const {refreshToken: _refreshToken, ...persistedSession} = session;
    localStorage.setItem(AUTH_SESSION_STORAGE_KEY, JSON.stringify(persistedSession));
  } catch {
    // Ignore storage failures in restricted browser modes.
  }
}

export function clearStoredAuthSession(): void {
  try {
    localStorage.removeItem(AUTH_SESSION_STORAGE_KEY);
  } catch {
    // Ignore storage failures in restricted browser modes.
  }
}
